(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sn-model-photography"]) return;
  try {
    
/* Scooter Narcotics model photos, 16 October 2026.
 * Presentation only: never modifies products, fitment, cart, storage or click handlers.
 * Model-family images are not claims of exact-year compatibility.
 */
(() => {
  'use strict';
  const cdn = 'https://cdn.shopify.com/s/files/1/0977/9088/6260/files/';
  const photos = Object.freeze({
    'Vespa Sprint 150': ['sn-vespa-sprint-150-model.webp?v=1792135863', 'https://www.vespa.cn/car/22.html'],
    'Vespa Primavera 150': ['sn-vespa-primavera-150-model.jpg?v=1792136805', 'https://www.vespa.cn/models/primavera/primavera-150-2024/'],
    'Vespa LX 150': ['sn-vespa-lx-150-model.avif?v=1792136270', 'https://www.vespa.co.th/lx'],
    'Honda ADV 150': ['sn-honda-adv-150-model.jpg?v=1792136639', 'https://global.honda/jp/news/2019/2191220-adv150.html'],
    'Honda ADV 160': ['sn-honda-adv-160-model.jpg?v=1792136457', 'https://global.honda/jp/news/2022/2221028-adv160.html'],
    'Yamaha Aerox': ['sn-yamaha-aerox-model.png?v=1792136618', 'https://shop.yamaha-motor-india.com/products/buy-aerox-155'],
    'Yamaha NMAX': ['sn-yamaha-nmax-model.jpg?v=1792136319', 'https://www.yamaha-motor.com.tw/news/news-202509-nmax'],
    'Scomadi 200': ['sn-scomadi-200-model.png?v=1792136796', 'https://scomadi.com/'],
    'Royal Alloy 200': ['sn-royal-alloy-200-model.jpg?v=1792136875', 'https://www.moto.it/listino/royal-alloy/gp-200/gp-200-s-2019-20/GZLTSt'],
    'Royal Alloy 300': ['sn-royal-alloy-300-model.png?v=1792136468', 'https://royalalloy.com.au/gp300/']
  });
  let observer = null;
  let frame = 0;
  let activeGrid = null;

  function applyPhotos() {
    frame = 0;
    if (!activeGrid || !activeGrid.isConnected) return;
    activeGrid.querySelectorAll('.modeltile[data-model]').forEach((tile) => {
      const name = tile.dataset.model;
      const photo = photos[name];
      const media = tile.querySelector('.media');
      if (!photo || !media) return;
      const src = cdn + photo[0] + '&width=720';
      if (media.dataset.snModelPhoto === src && media.querySelector('[data-sn-model-photo-image], .sn-photo-unavailable')) return;
      const image = document.createElement('img');
      image.dataset.snModelPhotoImage = 'true';
      image.dataset.photoSource = photo[1];
      image.alt = name + ' — model-family reference; select the exact vehicle version';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 720;
      image.height = 540;
      image.addEventListener('error', () => {
        if (!image.isConnected) return;
        const fallback = document.createElement('div');
        fallback.className = 'sn-photo-unavailable';
        const label = document.createElement('strong');
        label.textContent = name;
        const help = document.createElement('small');
        help.textContent = 'Photo temporarily unavailable';
        fallback.append(label, help);
        media.replaceChildren(fallback);
      }, { once: true });
      image.src = src;
      media.dataset.snModelPhoto = src;
      media.replaceChildren(image);
    });
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(applyPhotos);
  }

  function init() {
    const marker = document.querySelector('[data-sn-model-photography]');
    const grid = document.querySelector('#sn-storefront #modelGrid');
    if (!marker || !grid) return;
    if (observer) observer.disconnect();
    if (frame) window.cancelAnimationFrame(frame);
    frame = 0;
    activeGrid = grid;
    if (!document.getElementById('sn-model-photo-note')) {
      const note = document.createElement('p');
      note.id = 'sn-model-photo-note';
      note.textContent = 'Photos identify model families; colours and generations may vary.';
      grid.insertAdjacentElement('beforebegin', note);
    }
    applyPhotos();
    observer = new MutationObserver(schedule);
    observer.observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-rider-weather"] && !Shopify.designMode) return;
  try {
    
(function(){
'use strict';
if(window.snRiderWeatherLoaded)return;
window.snRiderWeatherLoaded=true;
const template=document.getElementById('sn-weather-template');
const labels=document.getElementById('sn-weather-i18n');
if(!template||!labels)return;
const T=JSON.parse(labels.textContent);
const areas=['Ang Mo Kio','Bedok','Bishan','Boon Lay','Bukit Batok','Bukit Merah','Bukit Panjang','Bukit Timah','Central Water Catchment','Changi','Choa Chu Kang','City','Clementi','Geylang','Hougang','Jalan Bahar','Jurong East','Jurong Island','Jurong West','Kallang','Lim Chu Kang','Mandai','Marine Parade','Novena','Pasir Ris','Paya Lebar','Pioneer','Pulau Tekong','Pulau Ubin','Punggol','Queenstown','Seletar','Sembawang','Sengkang','Sentosa','Serangoon','Southern Islands','Sungei Kadut','Tampines','Tanglin','Tengah','Toa Payoh','Tuas','Western Islands','Western Water Catchment','Woodlands','Yishun'];
const format=d=>new Intl.DateTimeFormat('en-SG',{timeZone:'Asia/Singapore',day:'numeric',month:'short',hour:'numeric',minute:'2-digit'}).format(new Date(d));
const dateKey=d=>new Intl.DateTimeFormat('en-CA',{timeZone:'Asia/Singapore',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date(d));
const months=['January','February','March','April','May','June','July','August','September','October','November','December'];
function appointment(text){
const m=text.match(/(\d{1,2})\s+(January|February|March|April|May|June|July|August|September|October|November|December)\s+(\d{4})\s+at\s+(\d{1,2}):(\d{2})\s*(AM|PM)/i);
if(!m)return null;
const hour=Number(m[4])%12+(m[6].toUpperCase()==='PM'?12:0);
const d=new Date(`${m[3]}-${String(months.findIndex(v=>v.toLowerCase()===m[2].toLowerCase())+1).padStart(2,'0')}-${m[1].padStart(2,'0')}T${String(hour).padStart(2,'0')}:${m[5]}:00+08:00`);
return Number.isFinite(+d)?d:null;
}
let cached=null,cacheAt=0,inflight=null;
async function load(){
if(cached&&Date.now()-cacheAt<300000)return cached;
if(inflight)return inflight;
inflight=Promise.allSettled(['two-hr-forecast','twenty-four-hr-forecast','four-day-outlook'].map(async path=>{
const r=await fetch('https://api-open.data.gov.sg/v2/real-time/api/'+path,{signal:AbortSignal.timeout(12000)});
if(!r.ok)throw Error('weather');const body=await r.json();if(body.code!==0||!body.data)throw Error('weather');return body.data;
})).then(results=>{
const data=results.map(r=>r.status==='fulfilled'?r.value:null);
if(data.every(v=>!v))throw Error('weather');
cached=data;cacheAt=Date.now();return data;
}).finally(()=>{inflight=null;});
return inflight;
}
function fresh(issued,maxAge){const age=Date.now()-Date.parse(issued);return age>=-300000&&age<maxAge;}
function within(t,p){return p&&+t>=Date.parse(p.start)&&+t<Date.parse(p.end);}
function forecast(data,time,area){
const two=data[0]?.items?.slice().sort((a,b)=>Date.parse(b.update_timestamp||b.timestamp)-Date.parse(a.update_timestamp||a.timestamp))[0];
if(two&&fresh(two.update_timestamp||two.timestamp,3*3600000)&&within(time,two.valid_period)){
const f=two.forecasts?.find(f=>f.area===area);if(f)return {text:f.forecast,type:T.two,issued:two.update_timestamp||two.timestamp,period:two.valid_period};
}
const day=data[1]?.records?.slice().sort((a,b)=>Date.parse(b.updatedTimestamp)-Date.parse(a.updatedTimestamp))[0];
if(day&&fresh(day.updatedTimestamp,24*3600000)&&within(time,day.general?.validPeriod)){
const period=day.periods?.find(p=>within(time,p.timePeriod));
const values=period?Object.values(period.regions).map(r=>r.text):[];
const allRegions=values.length===5&&values.every(v=>v===values[0]);
return {text:allRegions?values[0]:day.general.forecast.text,type:allRegions?T.day+' · '+T.all_regions:T.day,issued:day.updatedTimestamp,period:allRegions?period.timePeriod:day.general.validPeriod,temperature:day.general.temperature,wind:day.general.wind,national:true};
}
const four=data[2]?.records?.slice().sort((a,b)=>Date.parse(b.updatedTimestamp)-Date.parse(a.updatedTimestamp))[0];
if(four&&fresh(four.updatedTimestamp,36*3600000)){
const f=four.forecasts?.find(f=>dateKey(f.timestamp)===dateKey(time));
if(f)return {text:f.forecast.summary||f.forecast.text,type:T.four,issued:four.updatedTimestamp,temperature:f.temperature,wind:f.wind,national:true};
}
return {text:T.unknown,type:T.unavailable,missing:true};
}
function weatherRisk(f){
if(!f||f.missing)return 0;
return /thunder|storm/i.test(f.text)?2:/rain|shower|drizzle|sleet|snow|hail/i.test(f.text)?1:0;
}
function journeyWeather(trip){
const samples=new Set([0,1]),duration=+trip.arrive-+trip.leave;
const steps=Math.max(100,Math.ceil(duration/60000));
for(let i=1;i<steps;i++)samples.add(i/steps);
if(trip.route?.total>0)for(const distance of trip.route.cumulative)samples.add(distance/trip.route.total);
const forecasts=[trip.from,trip.to];
for(const p of samples){
const time=new Date(+trip.leave+duration*p);
if(trip.route){const area=nearestArea(trip.data,routePoint(trip.route,p),p<.5?trip.area:'Sungei Kadut');forecasts.push(forecast(trip.data,time,area));}
else{forecasts.push(forecast(trip.data,time,trip.area),forecast(trip.data,time,'Sungei Kadut'));}
}
return {risk:Math.max(...forecasts.map(weatherRisk)),missing:forecasts.some(f=>f.missing)};
}
function detail(f){
if(f.missing)return T.limited;
let s=f.type+' · '+T.issued+' '+format(f.issued)+'.';
if(f.period)s+=' '+T.valid+' '+format(f.period.start)+' – '+format(f.period.end)+'.';
if(f.temperature)s+=' '+T.temp+' '+f.temperature.low+'–'+f.temperature.high+'°C.';
if(f.wind)s+=' '+T.wind+' '+f.wind.direction+' '+f.wind.speed.low+'–'+f.wind.speed.high+' km/h.';
if(f.national)s+=' '+T.outlook;
return s;
}
function setupRadar(panel,el,put){
let frames=[],timer=null,loading=false,latest=0,active=false;
const halt=()=>{clearInterval(timer);timer=null;put('radarplay',T.radar_play);};
function show(){
const f=frames[Number(el('radarprogress').value)];if(!f)return;
el('radarimage').src=f.src;
put('radartime',format(f.time)+' SGT');
el('radarprogress').setAttribute('aria-valuetext',format(f.time)+' SGT');
}
async function refresh(){
if(loading)return;loading=true;active=true;halt();el('radarload').disabled=true;
el('radarcontent').hidden=true;put('radarstatus',T.radar_loading);
try{
const response=await fetch('https://api-open.data.gov.sg/v2/real-time/api/weather-radar-images/70km',{signal:AbortSignal.timeout(12000)});
if(!response.ok)throw Error('radar');const json=await response.json();
const records=json.data?.records;if(json.code!==0||!records?.length)throw Error('radar');
const timestamp=records.map(r=>Date.parse(r.timestamp)).filter(Number.isFinite).sort((a,b)=>b-a)[0];
if(!timestamp||timestamp>Date.now()+600000)throw Error('radar');
await new Promise((resolve,reject)=>{const base=new Image();const timeout=setTimeout(()=>reject(Error('basemap')),10000);base.onload=()=>{clearTimeout(timeout);resolve();};base.onerror=()=>{clearTimeout(timeout);reject(Error('basemap'));};base.src='https://www.weather.gov.sg/wp-content/themes/wiptheme/assets/img/base-853.png';});
const results=await Promise.all(Array.from({length:12},(_,i)=>{
const time=timestamp-(11-i)*300000;
const stamp=new Date(time+8*3600000).toISOString().slice(0,19).replace(/[-:T]/g,'');
const src='https://www.weather.gov.sg/files/rainarea/50km/v2/dpsri_70km_'+stamp+'00dBR.dpsri.png';
return new Promise(resolve=>{
const im=new Image();const expiry=setTimeout(()=>{im.onload=null;im.onerror=null;resolve(null);},10000);
im.referrerPolicy='no-referrer';im.onload=()=>{clearTimeout(expiry);resolve({src,time});};im.onerror=()=>{clearTimeout(expiry);resolve(null);};im.src=src;
});
}));
frames=results.filter(Boolean);if(!frames.length)throw Error('radar');
latest=frames[frames.length-1].time;
el('radarprogress').max=frames.length-1;el('radarprogress').value=frames.length-1;el('radarprogress').disabled=frames.length<2;el('radarplay').disabled=frames.length<2;
show();el('radarcontent').hidden=false;
put('radarstatus',(Date.now()-latest>1200000?T.radar_stale:T.radar_ready)+' · '+frames.length+' '+T.radar_frames);
put('radarload',T.radar_refresh);
}catch(e){put('radarstatus',T.radar_error);el('radarcontent').hidden=true;}finally{loading=false;el('radarload').disabled=false;}
}
el('radarload').addEventListener('click',refresh);
el('radardetails').addEventListener('toggle',()=>{if(el('radardetails').open){if(!frames.length||Date.now()-latest>300000)refresh();}else{halt();}});
el('radarprogress').addEventListener('input',()=>{halt();show();});
el('radarplay').addEventListener('click',()=>{
if(timer){halt();return;}if(frames.length<2)return;
put('radarplay',T.radar_pause);el('radarprogress').value=0;show();
timer=setInterval(()=>{el('radarprogress').value=(Number(el('radarprogress').value)+1)%frames.length;show();},700);
});
document.addEventListener('visibilitychange',()=>{if(document.hidden)halt();});
const refreshTimer=setInterval(()=>{
if(!panel.isConnected){clearInterval(refreshTimer);halt();return;}
if(active&&el('radardetails').open&&!document.hidden)refresh();
},300000);
}

let mapsLoading;
function loadMaps(key){
if(window.google?.maps?.importLibrary)return Promise.resolve();
if(mapsLoading)return mapsLoading;
mapsLoading=new Promise((resolve,reject)=>{
const script=document.createElement('script');
const timeout=setTimeout(()=>reject(Error('maps_timeout')),20000);
window.snRideMapsReady=()=>{clearTimeout(timeout);resolve();};
script.src='https://maps.googleapis.com/maps/api/js?key='+encodeURIComponent(key)+'&v=weekly&loading=async&callback=snRideMapsReady&region=SG&language=en';
script.async=true;script.onerror=()=>{clearTimeout(timeout);reject(Error('maps_load'));};document.head.append(script);
}).catch(error=>{mapsLoading=null;throw error;});return mapsLoading;
}
function km(a,b){const r=Math.PI/180,dlat=(b.lat-a.lat)*r,dlng=(b.lng-a.lng)*r;return 12742*Math.asin(Math.min(1,Math.sqrt(Math.sin(dlat/2)**2+Math.cos(a.lat*r)*Math.cos(b.lat*r)*Math.sin(dlng/2)**2)));}
function nearestArea(data,point,fallback){
const metadata=data?.[0]?.area_metadata||data?.[0]?.areaMetadata||[];
let best=Infinity,name=fallback;
for(const area of metadata){const p=area.label_location||area.labelLocation;if(!p)continue;const d=km(point,{lat:p.latitude,lng:p.longitude});if(d<best){best=d;name=area.name;}}
return name;
}
function routePoint(route,progress){
const distance=route.total*Math.max(0,Math.min(1,progress));let low=1,high=route.cumulative.length-1;
while(low<high){const mid=(low+high)>>>1;if(route.cumulative[mid]<distance)low=mid+1;else high=mid;}
const i=low;
const a=route.path[i-1],b=route.path[i],length=route.cumulative[i]-route.cumulative[i-1];
const p=length?(distance-route.cumulative[i-1])/length:0;
return {lat:a.lat+(b.lat-a.lat)*p,lng:a.lng+(b.lng-a.lng)*p};
}
function setupJourney(panel,el,put){
let cachedRoute=null,map=null,marker=null,mapMode=null,objects=[],generation=0,lastHeading=null,cameraHeading=null;
const clear=()=>{generation++;for(const object of objects){object.setMap?.(null);object.remove?.();}objects=[];marker=null;lastHeading=null;cameraHeading=null;};
function reset(){clear();el('mapbox').hidden=true;put('mapstatus','');}
async function prepare(area,postal){
const key=panel.dataset.mapsKey;if(!key)throw Error(T.route_error);
const identity=postal||area;
if(cachedRoute?.identity===identity)return cachedRoute;
await loadMaps(key);
const [{Geocoder},{Route}]=await Promise.all([google.maps.importLibrary('geocoding'),google.maps.importLibrary('routes')]);
const geocoder=new Geocoder();
const {results}=await geocoder.geocode({address:postal?'Singapore '+postal:area+', Singapore',componentRestrictions:{country:'SG'}});
const origin=results?.find(r=>r.address_components.some(c=>c.types.includes('country')&&c.short_name==='SG'));
if(!origin||origin.partial_match)throw Error(T.postal_error);
const p=origin.geometry.location.toJSON();
if(p.lat<1.15||p.lat>1.5||p.lng<103.55||p.lng>104.12)throw Error(T.postal_error);
const {routes}=await Route.computeRoutes({origin:p,destination:'60 Jalan Lam Huat, Singapore 737869',travelMode:'DRIVING',routingPreference:'TRAFFIC_UNAWARE',fields:['path','durationMillis','distanceMeters','warnings'],region:'SG'});
const route=routes?.[0];if(!route?.path?.length||!Number.isFinite(route.durationMillis))throw Error(T.route_error);
const path=route.path.map(v=>({lat:typeof v.lat==='function'?v.lat():v.lat,lng:typeof v.lng==='function'?v.lng():v.lng}));
if(path.length<2)throw Error(T.route_error);
const cumulative=[0];for(let i=1;i<path.length;i++)cumulative.push(cumulative[i-1]+km(path[i-1],path[i]));
cachedRoute={identity,path,cumulative,total:cumulative.at(-1),mins:Math.max(1,Math.ceil(route.durationMillis/60000)),distance:route.distanceMeters,origin:origin.formatted_address,warnings:route.warnings||[],point:p};return cachedRoute;
}
async function show(route,mode='3d'){
clear();const version=generation;el('mapbox').hidden=false;put('mapstatus',T.map_loading);el('map3d').disabled=true;el('map2d').disabled=true;
try{
if(mode==='3d'){
const {Map3DElement,Polyline3DElement,Marker3DElement}=await google.maps.importLibrary('maps3d');if(version!==generation)return;
if(mapMode!=='3d'){map=new Map3DElement({center:{...route.path[0],altitude:30},range:850,tilt:55,heading:0,mode:'HYBRID',gestureHandling:'COOPERATIVE'});el('mapcanvas').replaceChildren(map);mapMode='3d';map.addEventListener('gmp-error',()=>put('mapstatus',T.map_error));}
const line=new Polyline3DElement({path:route.path,strokeColor:'#ff005c',strokeWidth:8,altitudeMode:'CLAMP_TO_GROUND',drawsOccludedSegments:true});
marker=new Marker3DElement({position:route.path[0],altitudeMode:'CLAMP_TO_GROUND',label:T.my_scooter,sizePreserved:true,drawsWhenOccluded:true});
const end=new Marker3DElement({position:route.path.at(-1),label:T.workshop,altitudeMode:'CLAMP_TO_GROUND'});objects=[line,marker,end];map.append(...objects);
}else{
const {Map,Polyline}=await google.maps.importLibrary('maps');const {Marker}=await google.maps.importLibrary('marker');if(version!==generation)return;
if(mapMode!=='2d'){el('mapcanvas').replaceChildren();map=new Map(el('mapcanvas'),{center:route.path[0],zoom:14,gestureHandling:'cooperative',mapTypeControl:false});mapMode='2d';}
const line=new Polyline({path:route.path,strokeColor:'#ff005c',strokeWeight:5,map});marker=new Marker({position:route.path[0],map,title:T.my_scooter});const end=new Marker({position:route.path.at(-1),map,label:'SN'});objects=[line,marker,end];
}
if(mapMode==='3d'){map.range=850;map.tilt=55;}
put('mapstatus',mode==='3d'?T.map_ready:T.map_2d_ready);move(route,Number(el('progress').value)/100);return true;
}catch(error){if(version===generation){put('mapstatus',T.map_error);}}
finally{el('map3d').disabled=false;el('map2d').disabled=false;}
}
function move(route,p,elapsed=0){
if(!marker||!map)return;const point=routePoint(route,p);
const lookAhead=Math.min(.02,.08/Math.max(route.total,.08));
const a=routePoint(route,Math.max(0,p-lookAhead)),b=routePoint(route,Math.min(1,p+lookAhead));
const radians=Math.PI/180,dl=(b.lng-a.lng)*radians;
const bearing=(Math.atan2(Math.sin(dl)*Math.cos(b.lat*radians),Math.cos(a.lat*radians)*Math.sin(b.lat*radians)-Math.sin(a.lat*radians)*Math.cos(b.lat*radians)*Math.cos(dl))/radians+360)%360;
const heading=0;
if(mapMode==='3d'&&heading!==lastHeading){
lastHeading=heading;
const icon=document.createElement('template');
icon.innerHTML='<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 100 100"><g transform="rotate('+heading+' 50 50)"><path d="M50 3 39 19h22Z" fill="#ff005c" stroke="white" stroke-width="2"/><rect x="45" y="19" width="10" height="17" rx="4" fill="#111" stroke="white" stroke-width="2"/><rect x="44" y="72" width="12" height="20" rx="5" fill="#111" stroke="white" stroke-width="2"/><path d="M27 35 50 30 73 35M30 32v9M70 32v9" stroke="#ddd" stroke-width="5" stroke-linecap="round"/><path d="M37 35Q50 26 63 35L60 67Q67 78 58 83H42Q33 78 40 67Z" fill="#dcff00" stroke="#111" stroke-width="3"/><path d="M40 37Q50 31 60 37L58 48H42Z" fill="#b9e9ff" stroke="#333" stroke-width="2"/><rect x="42" y="51" width="16" height="24" rx="7" fill="#222"/><path d="M43 79h14" stroke="#ff005c" stroke-width="4"/></g></svg>';
marker.replaceChildren(icon);
}

if(cameraHeading===null||!elapsed)cameraHeading=bearing;
else cameraHeading+=((bearing-cameraHeading+540)%360-180)*(1-Math.exp(-elapsed/180));
cameraHeading=(cameraHeading+360)%360;
if(mapMode==='3d'){marker.position=point;map.center={...point,altitude:30};map.heading=cameraHeading;}else{marker.setPosition(point);map.setCenter(point);}
}
return {prepare,show,move,reset};
}

function mount(summary){
if(summary.dataset.snWeatherMounted)return;
summary.dataset.snWeatherMounted='true';
const panel=template.content.firstElementChild.cloneNode(true);summary.after(panel);
const prompt=document.createElement('div');prompt.className='sn-slot-reminder';prompt.setAttribute('role','status');
const promptText=document.createElement('p');promptText.textContent=T.pick;
const pickButton=document.createElement('button');pickButton.type='button';pickButton.textContent=T.go_to_slot;
prompt.append(promptText,pickButton);panel.before(prompt);
const calendar=summary.closest('.diag-cal-wrap,.scheduler,.cal')||summary.parentElement;
const picker=calendar.querySelector('#diag-time-wrap,#time-picker,[id^="bj-tw-"]');
function slotReady(){return !!appointment(summary.textContent)&&getComputedStyle(summary).display!=='none';}
function focusSlot(){
 const hasTimes=picker&&Array.from(picker.querySelectorAll('button')).some(b=>!b.disabled&&getComputedStyle(b).display!=='none');
 const target=hasTimes?picker:calendar;
 target.setAttribute('tabindex','-1');target.scrollIntoView({behavior:'smooth',block:'center'});target.focus({preventScroll:true});
}
pickButton.addEventListener('click',focusSlot);
function syncSlot(){const ready=slotReady();panel.hidden=!ready;prompt.hidden=ready;}
syncSlot();
const elements=new Map();
const el=k=>{if(!elements.has(k))elements.set(k,panel.querySelector('[data-wx="'+k+'"]'));return elements.get(k);};
const rider=panel.querySelector('.snwx-rider');
const put=(k,v)=>{const target=el(k);if(target.textContent===v)return;target.textContent=v;if(['fromweather','toweather','stage'].includes(k))target.classList.toggle('snwx-weather-alert',weatherRisk({text:v})>0);};

setupRadar(panel,el,put);
let revision=0,timer=null,trip=null,reviewed=false;
const journey=setupJourney(panel,el,put);
el('journeydetails').addEventListener('toggle',async()=>{
if(!el('journeydetails').open){stop();return;}
if(trip?.route){el('mapbox').hidden=false;await journey.show(trip.route,'2d');}
});
el("map3d").addEventListener("click",()=>{stop();if(trip?.route)journey.show(trip.route,"3d");});
el("map2d").addEventListener("click",()=>{stop();if(trip?.route)journey.show(trip.route,"2d");});
document.addEventListener("visibilitychange",()=>{if(document.hidden)stop();});
const confirm=summary.id==='diag-appt'?document.getElementById('diag-book'):summary.id==='appt-summary'?document.querySelector('#order-form .submit-btn'):document.getElementById(summary.id.replace('bj-appt-','bj-book-'));
function finishReview(skipped=false){reviewed=true;put('status',skipped?T.skipped:trip?.risk?T.rain_reviewed:T.reviewed);const form=summary.closest('#diagnostic,.snbj,.sn-service');const next=form&&Array.from(form.querySelectorAll('input[type="text"],input[type="email"],input[type="tel"]')).find(x=>!x.closest('.snwx')&&!x.value.trim()&&x.getClientRects().length);const target=next||confirm;target?.scrollIntoView({behavior:'smooth',block:'center'});target?.focus({preventScroll:true});}
el('review').addEventListener('click',()=>finishReview());el('skip').addEventListener('click',()=>finishReview(true));
el('sitout').addEventListener('click',()=>{reviewed=false;stop();put('status',T.rain_declined);focusSlot();});
function gate(event){if(!slotReady()){event.preventDefault();event.stopImmediatePropagation();syncSlot();focusSlot();return;}if(reviewed)return;event.preventDefault();event.stopImmediatePropagation();put('status',trip?.risk?T.rain_required:T.review_required);panel.scrollIntoView({behavior:'smooth',block:'start'});el(trip?.risk?'review':'postal').focus({preventScroll:true});}
if(confirm){window.addEventListener('click',event=>{if(event.target instanceof Element&&event.target.closest('button')===confirm)gate(event);},true);if(confirm.form)window.addEventListener('submit',event=>{if(event.target===confirm.form)gate(event);},true);}
function stop(){if(timer!==null)cancelAnimationFrame(timer);timer=null;put('play',T.play);}
function invalidate(){el('sitout').hidden=true;el('rainnotice').hidden=true;put('review',T.review);revision++;reviewed=false;el('review').hidden=true;el('skip').hidden=true;stop();trip=null;journey.reset();el('result').hidden=true;el('extras').hidden=true;el('journeydetails').open=false;el('forecastdetails').open=false;put('status',slotReady()?T.ride_ready:T.pick);syncSlot();}
new MutationObserver(()=>{invalidate();}).observe(summary,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['style','class']});
['buffer','postal'].forEach(k=>el(k).addEventListener('input',()=>{invalidate();put('status',T.waiting);}));
function showJourneyWeather(){
const wet=trip.risk>0;
put('weatherheading',trip.risk===2?T.thunder_heading:T.rain_heading);
put('weatherquestion',trip.risk===2?T.thunder_question:T.rain_question);
el('rainnotice').hidden=!wet;el('sitout').hidden=!wet;put('review',wet?T.rain_accept:T.review);
const advice=trip.risk===2?T.thunder:wet?T.rain:trip.missing?T.limited:T.fair;
put('advice',wet?(trip.missing?T.limited:''):advice);el('advice').hidden=wet&&!trip.missing;
}
function renderFrame(p,elapsed=0){
el('progress').value=p;
rider.style.transform='translate3d('+p+'%,0,0)';
if(trip?.route)journey.move(trip.route,p/100,elapsed);
}
function stage(p=Number(el('progress').value)){
if(!trip)return;
const time=+trip.leave+(+trip.arrive-+trip.leave)*p/100;
const point=trip.route?routePoint(trip.route,p/100):null;
const near=point?nearestArea(trip.data,point,p<50?trip.area:'Sungei Kadut'):null;
const f=p===0?trip.from:p===100?trip.to:point?forecast(trip.data,new Date(time),near):null;
if(weatherRisk(f)>trip.risk){trip.risk=weatherRisk(f);reviewed=false;showJourneyWeather();}
put('stagedetail',f?detail(f)+(point?' '+T.area_approx:''):'');
put('stage',format(time)+' · '+(p===0?trip.area:p===100?T.workshop:near?T.near+' '+near:T.mid)+(f?' · '+f.text:''));
panel.dataset.weather=f?.missing?'unknown':weatherRisk(f)===2?'thunder':weatherRisk(f)===1?'rain':'neutral';
}
el('progress').addEventListener('input',()=>{stop();renderFrame(Number(el('progress').value));stage();});
el('play').addEventListener('click',()=>{
if(timer!==null){stop();return;}if(!trip)return;
let progress=Number(el('progress').value);if(progress>=100)progress=0;
const duration=trip.route?Math.max(60000,Math.min(120000,trip.route.total*3500)):60000;
renderFrame(progress);stage(progress);put('play',T.pause);
let last=performance.now(),lastText=last;
function tick(now){
if(!panel.isConnected||document.hidden){stop();return;}
const elapsed=Math.min(64,Math.max(0,now-last));last=now;
progress=Math.min(100,progress+elapsed/duration*100);renderFrame(progress,elapsed);
if(now-lastText>=250||progress>=100){stage(progress);lastText=now;}
if(progress>=100){stop();return;}
timer=requestAnimationFrame(tick);
}
timer=requestAnimationFrame(tick);
});
el('check').addEventListener('click',async()=>{
stop();reviewed=false;trip=null;el('sitout').hidden=true;el('rainnotice').hidden=true;put('review',T.review);el('review').hidden=true;el('skip').hidden=true;const version=++revision;el('result').hidden=true;el('extras').hidden=true;el('journeydetails').open=false;el('forecastdetails').open=false;
const appt=appointment(summary.textContent);
if(!appt||getComputedStyle(summary).display==='none'){put('status',T.pick);syncSlot();focusSlot();return;}
let mins=0,area='';
const buffer=Number(el('buffer').value),postal=el('postal').value.trim(),routing=true;
if(el('buffer').value===''||!Number.isFinite(buffer)||buffer<0||buffer>60){put('status',T.invalid);return;}
if(!/^\d{6}$/.test(postal)){put('status',T.postal_error);return;}
put('status',routing?T.route_loading:T.loading);el('check').disabled=true;
try{
const data=await load().catch(()=>[null,null,null]);if(version!==revision)return;
const route=routing?await journey.prepare(area,postal):null;if(version!==revision)return;
if(route){mins=route.mins;if(postal)area=nearestArea(data,route.point,'');}
const arrive=new Date(+appt-buffer*60000),leave=new Date(+arrive-mins*60000);
if(+leave<Date.now()){put('status',T.past);el('skip').hidden=false;return;}
el('routetools').hidden=!route;
(route?el('mapplay'):panel.querySelector('.snwx-simhead')).append(el('play'));
if(route){put('routesummary',T.route_summary+' · '+(route.distance/1000).toFixed(1)+' km · '+mins+' '+T.minutes+' · '+route.origin);put('routewarnings',route.warnings.join(' '));}
const from=forecast(data,leave,area),to=forecast(data,arrive,'Sungei Kadut');
trip={leave,arrive,area,from,to,route,data};put('leave',format(leave));put('arrive',format(arrive));put('from',area);put('fromweather',from.text);put('toweather',to.text);put('fromdetail',detail(from));put('todetail',detail(to));
Object.assign(trip,journeyWeather(trip));showJourneyWeather();
put('status',T.trip_summary.replace('{minutes}',mins).replace('{buffer}',buffer));
if(route){el('mapbox').hidden=true;}el('result').hidden=false;el('extras').hidden=false;el('review').hidden=false;el('skip').hidden=true;renderFrame(0);stage(0);
}catch(e){if(version===revision){put('status',routing?(e.message===T.postal_error?T.postal_error:T.route_error):T.error);el('skip').hidden=false;}}finally{el('check').disabled=false;}
});
}
function init(){document.querySelectorAll('#diag-appt,#appt-summary,[id^="bj-appt-"]').forEach(mount);}
init();document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();
})();
